import { Component, OnInit, inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { HelperService } from '@shared/services/helper.service';
import { AssetsService } from '@shared/services/assets.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { Modal, ModalConfig, ModalType, NonPersistedModalName, isModalConfig } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';

@Component({
  selector: 'slotcom-notify-discontinued-modal',
  templateUrl: './notify-discontinued-modal.component.html',
  styleUrls: ['./notify-discontinued-modal.component.scss'],
  standalone: true,
  imports: [ButtonComponent, SharedModule, NavigationButtonComponent],
})
export class NotifyDiscontinuedModalComponent implements OnInit {
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private assetsService = inject(AssetsService);
  logger = inject(LoggerService);
  private eventManager = inject(EventManager);
  notifyDiscontinuedModalData = inject<Modal | ModalConfig>(MAT_DIALOG_DATA);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gameIcon: any;
  canPurchase: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  date: any;

  ngOnInit() {
    this.assetsService.gamesVersion$.subscribe({
      next: (versions) => {
        if (isModalConfig(this.notifyDiscontinuedModalData)) {
          const notifyDiscontinuedPersisted = this.notifyDiscontinuedModalData as ModalConfig;
          this.canPurchase = false;
          this.date = {
            day: notifyDiscontinuedPersisted.properties.day,
            month: notifyDiscontinuedPersisted.properties.month,
          };

          const url = this.assetsService.getGameIconUrlLegacy(notifyDiscontinuedPersisted.properties.gameId, versions);
          this.gameIcon = { 'background-image': `url('${url}')` };
        } else {
          const notifyDiscontinuedView = this.notifyDiscontinuedModalData as Modal;
          this.canPurchase = notifyDiscontinuedView.data.purchase;
          this.date = {
            day: notifyDiscontinuedView.data.day,
            month: notifyDiscontinuedView.data.month,
          };

          const url = this.assetsService.getGameIconUrlLegacy(notifyDiscontinuedView.data.gameId, versions);
          this.gameIcon = { 'background-image': `url('${url}')` };
        }
      },
      error: (error) => this.logger.error(error),
    });
  }

  public closeDialog(unlocked: boolean): void {
    if (isModalConfig(this.notifyDiscontinuedModalData)) {
      this.eventManager.closeModal(
        new Modal(this.notifyDiscontinuedModalData.id, ModalType.Persisted, this.notifyDiscontinuedModalData)
      );
    } else {
      this.eventManager.closeModal(
        new Modal(NonPersistedModalName.NotifyDiscontinuedModalComponent, ModalType.View, { message: unlocked })
      );
    }
  }
}
